// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aerodrome-classification.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aerodrome-classification/aerodrome-classification.js';

mount([g0]);
